export default __webpack_public_path__ + "static/media/department.1220dca1.svg";